import React from 'react'
import { IdleStyles, TeacherIdleStyles } from '../Style'
import { CheckMic_Go } from 'assets'
import { ReactComponent as MicButton } from 'assets/icons/MicButton.svg'
import { Img } from 'styles/GlobalStyle'
import { AnimatePresence } from "motion/react"
import { check_mic_male, check_mic_female } from 'introductions'
import { _check_mic_male, _check_mic_female } from 'introductions/highGrades'
import ReactPlayer from 'react-player';
import * as motion from "motion/react-client"

const Idle = (props) => {
    const { start, isMaleGender, isHighGrade, isTeacherCheck } = props

    const lowGradesRecord = isMaleGender ? check_mic_male : check_mic_female
    // לתקן הקלטה לנקבה
    const highGradesRecord = isMaleGender ? _check_mic_male : _check_mic_female

    if (isTeacherCheck) {
        return (
            <AnimatePresence>
                <motion.div
                    exit={{ opacity: 0 }}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.7 }}
                    key="idle-teacher"
                >
                    <TeacherIdleStyles>
                        <div className='instructions'>
                            {"שימי אוזניות ורמקול קרוב לפה"}
                            <br />
                            {"לחצי על הכפתור הכתום ואמרי: \"אני רוצה להתחיל\""}
                        </div>
                        <div className='check-mic-teacher clickable' onClick={start}>
                            <MicButton />
                        </div>
                        <Img className="cartoon-corner" style={{ height: 222 }} src={CheckMic_Go} />
                    </TeacherIdleStyles>
                </motion.div>
            </AnimatePresence>
        )
    }

    return (
        <>
            {/* <motion.div
                exit={{ opacity: 0 }}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }} // אם shouldAnimate true, מתחילים להיעלם
                transition={{ duration: 0.7 }}
                key="idle"
            > */}
                <IdleStyles>
                    <div className='side-cartoon'>
                        <Img src={CheckMic_Go} />
                    </div>
                    <div className='content'>
                        <div className='check-mic' onClick={start}>
                            <MicButton />
                        </div>
                        {/* <OrangeButton  /> */}
                    </div>
                </IdleStyles>
            {/* </motion.div> */}
            <ReactPlayer
                playing={true}
                url={isHighGrade ? highGradesRecord : lowGradesRecord}
                controls={true}
                width='0px' height='0px'
                onEnded={() => { }}
            />
        </>
    )
}

export default Idle